"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowedHost = void 0;
const web_env_1 = require("@snapchat/web-env");
// don't do exposure logging for localhost, browserstack etc
const DISABLED_HOSTS = ["localhost", "mesh.sc-corp", "bs-local.com"];
function isAllowedHost() {
    if ((0, web_env_1.isRunningOnServer)()) {
        return false;
    }
    return !DISABLED_HOSTS.some((host) => window.document.location.host.includes(host));
}
exports.isAllowedHost = isAllowedHost;
//# sourceMappingURL=hosts.js.map